import { BaseRouteService } from "core/services";

class FacilityOrderProductRouteService extends BaseRouteService {
	constructor() {
		super("facility-order-products");
	}

	upsert(resource) {
		return super.create(`${this.base}/upsert`, resource);
	}
}

export default FacilityOrderProductRouteService;
